import { Typography } from '@musinsa/mds';
import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';

const DISPLAY_NAME = 'ProductInformation.SalesVolume';

interface Props {
  totalQuantity: number;
  className?: string;
}

export const SalesVolume: FC<Props> = ({ totalQuantity, className }) => (
  <div>
    <Typography
      variant="textEtc11pxReg"
      colorScheme="gray-500"
      className={twMerge('pt-[6px]', className)}
    >
      판매수 {totalQuantity.toLocaleString()}
    </Typography>
  </div>
);

SalesVolume.displayName = DISPLAY_NAME;
